import axios from '~/utils/axios';

const getListCVApi = (param) => axios.get('/curriculumVitae', {params: param});
const deleteCVApi = (id) => axios.delete(`/curriculumVitae/${id}`);

export default {
    getListCVApi,
    deleteCVApi
};
